export default class ListAttachmentRecordsByPropertyIdError extends Error {

}
